import { ReverseMap } from 'lib/types/base-types'

export enum Role {
  STREAMER = 'streamer',
  PARTNER = 'partner',
}

export type RoleType = ReverseMap<typeof Role>
